<i18n lang='yml' src='../i18n/InviteNetworkUser.yml'></i18n>
<template>
  <div>
    <flash :message_type="message_type" :message_text="message_text"/>
    <Form ref="observer" v-slot="{ errors }" @submit.="submitUserInput" @invalid-submit="setErrorMessage">
        <div class="row manage-membership">
          <div class="col-sm-12 col-md-5 col-xl-6">
            <Field 
              :name="$t('user')"  
              rules="required" 
              v-slot="{ errors, field }"
              v-model="selectedUser">
              <label for='user'>{{ $t('user') }}<span class="text-danger">*</span></label>
              <multi-select
                :options="getOptions(dropdownUsers)"
                searchable="true"
                class="single-select"
                @search-change="onTextEntry"
                v-bind="field"
                label="label"
                :internal-search="false"
                :loading="loading"
                :class="{'is-invalid': errors[0]}" 
                key="value"/>
              <div class="invalid-feedback" :id="`${$t('name')}_error`" v-if="errors[0]">
                <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                <span>{{ errors[0] }}</span> 
              </div>
            </Field>  
          </div>

          <div class="col-sm-12 col-md-4 col-xl-3 no-padding-md">
            <Field 
              :name="$t('role')"  
              rules="required" 
              v-slot="{ errors, field }"
              v-model="selectedRole">
              <label>{{ $t('role') }}<span class="text-danger">*</span></label>
              <multi-select
                :options="getOptions(dropdownRoles)"
                searchable="true"
                class="single-select"
                @search-change="onTextEntry"
                v-bind="field"
                label="label"
                :internal-search="false"
                :loading="loading"
                :class="{'is-invalid': errors[0]}" 
                key="value"/>
              <div class="invalid-feedback" :id="`${$t('role')}_error`" v-if="errors[0]">
                <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                <span>{{ errors[0] }}</span> 
              </div>
            </Field>  
          </div>
    
        <div class="col-sm-12 col-md-3 margin-top">
          <button type="submit" class="btn btn-success">
            <font-awesome-icon :icon="['fa', 'plus']"/>
            {{ $t('add') }}
          </button>
        </div>
      </div>
        <div v-if="Object.keys(errors).length > 0 && showErrorBanner" class="alert alert-danger" role="alert">
          <span class="red mr-2"> <font-awesome-icon :icon="['far', 'exclamation-circle']"/></span>
          {{ $t('error_warning') }}
        </div>
    </Form>
  </div>
</template>

<script>
  import { sendAjaxRequest } from '../../../shared/typescripts/ajax.ts'
  import { setErrorMessage } from '../../../shared/typescripts/error.ts'
  import { Form, Field } from 'vee-validate'
  import flash from '../../../shared/flash_messages/components/Flash.vue';
  
  export default {
    components: { 
      flash,
      Form, 
      Field 
    },
    props: {
      submit_path: { type: String },
      users_path: { type: String },
      roles_json: { type: String },
      container_id: { type: String },
    },
    data() {
      return {
        users: [],
        roles: JSON.parse(this.roles_json),
        selectedUser: null,
        selectedRole: null,
        loading: false,
        message_text: [],
        message_type: "",
        showErrorBanner: false,
      }
    },
    methods: {
      getOptions(data,) {
        let newArray = [];
        data.map((item) => {
          newArray.push({value: item.id, label: item.label})
        })
        return newArray
      },

      onTextEntry(search, loading) {
        // Three characters is long enough to limit search time so we aren't searching for single or double characters
        // which could produce thousands of results and take an exceptionally long time to run
        if(search.length >= 3) {
           this.loading = true

          sendAjaxRequest('GET', this.users_path, 'json', {q: search}, this.ajaxOnTextEntrySuccess, this.throwError)
        }
        else{
          this.users = [];
          this.loading=false
        }
      },

      ajaxOnTextEntrySuccess(data) {
        this.users = data;
        this.loading = false;
      },

      submitUserInput(event){
        const _vm = this
        let payload = []

        payload = { authenticity_token: $("meta[name='csrf-token']").attr("content"), 
                    container_membership: {user_id: this.selectedUser, 
                    network_role_id: this.selectedRole, container_id: this.container_id}}
           this.message_text = [];
           sendAjaxRequest('POST', this.submit_path, 'json', payload, this.ajaxSuccess)
          },

      ajaxSuccess(response) {
        if(response.error){
          this.message_type = "error";
          this.message_text.push(response.error)
        }
        else {
          this.loading = false;
          this.role = this.roles[0].id;
          window.location.replace(response.path);
        }
      },

      setErrorMessage({ valuese, errors, results }) {
        setErrorMessage(this, errors, true)
      },
    },
    computed: {
      dropdownUsers() {
        let results = [];
        this.users.forEach((item) => {
          results.push({
            id: item.user_id,
            label: `${item.last_name}, ${item.first_name} (${item.email})`
          });
        });

        return results;
      },
      dropdownRoles() {
        let results = [];
        JSON.parse(this.roles_json).forEach((item) => {
          results.push({
            id: item.id,
            label: item.name,
          });
        });
        return results;
      }
    }
  }
</script>
